import Link from 'Root/Component/Link'
import { useCurrentUserId } from 'lib/use-current-user-id'

import styles from './index.module.css'

interface Props {
  value: string
}

const Tag = ({ value }: Props) => {
  const userId = useCurrentUserId()

  if (!Boolean(userId)) {
    return <div className={styles.value}>{value}</div>
  }

  return (
    <Link className={styles.value} to={`/me/tags?q=${value}`}>
      {value}
    </Link>
  )
}

export default Tag
